









































































































    import Vue from 'vue'
    import {
      AssessmentStatusService,
      AssignmentService
    } from '@/services/'
    import { Button } from 'view-design'
    import UISpinner from '@/components/common/UISpinner.vue'
    import FileTab from './FileTab.vue'
    import { adminMode } from '@/helper/permission.helper'
    import BaseIcon from '../svgicons/BaseIcon.vue'
    export default Vue.extend({
      props: {
        categoryId: String,
        post: Object,
        showRetakeButton: Boolean,
        nextPost: Object
      },
      computed: {
        pageTopMessage(): string {
          const commonMessage = `We have evaulated your assignment and you scored ${this.lastSubmission.score}%.`
          const resultMessage = `You have ${ this.lastSubmission.status === 'passed' ? 'succesfully passed' : 'failed' } this assignment.<br>Thank You.`
          return `${commonMessage}<br>${resultMessage}`
        },
        resultMessageColor(): string {
          return this.lastSubmission && this.lastSubmission.status === 'passed' ? 'green' : 'red'
        },
        showingRetakeButton() :boolean {
          return (!this.lastSubmission && this.showRetakeButton) || (this.lastSubmission && this.lastSubmission.status === 'failed' && this.showRetakeButton)
        },
        submissionColor(): string {
          return this.lastSubmission && this.lastSubmission.status === "passed" ? "green" : "red";
        },
        postId(): string {
          return this.post ? this.post.id : ''
        },
        isAdmin() {
          return adminMode()
        },
        postContentType(): string {
          return this.post.contentType
        },
        buttonLabel(): string {
          return `${this.lastSubmission ? 'Retake' : 'Start'} ${this.contentTypeLabel[this.postContentType]}`
        },
        retakingAssignment(): boolean {
          return this.$route.query.retake
        },
        fileList(): {
          size: number,
          title: string,
          url: string,
          type: string  
        } {
          if (this.lastSubmission && !this.retakingAssignment) {
            return this.lastSubmission.submission ?? []  
          }
          return this.assignment.fileUrls ?? [] 
        }
      },
      data() {
        return {
          lastSubmission: null,
          questionCount: 0,
          correctCount: 0,
          incorrectCount: 0,
          fetchingSubmission: false,
          contentTypeLabel: {
            quiz: 'Quiz',
            assignment: 'Assignment'
          },
					assignment: {},
          showAssignmentQuestion: true
        };
      },
      async mounted() {
          await this.getLastSubmission();
          await this.getAssignmentByPostId()
      },
      methods: {
        goToNextPost() {
          this.$emit('goToNextPost')
        },
        async getLastSubmission() {
          if (this.isAdmin) return // don't make api calls if it's admin
          this.fetchingSubmission = true
          try {
            const fetchedSubmission = await AssessmentStatusService.getLastSubmissionByPostId(this.postId)
            this.lastSubmission = fetchedSubmission.data.lastSubmission
            if (this.lastSubmission && !this.retakingAssignment) {
              this.showAssignmentQuestion = true
            }
          }
          catch (error) {
              console.error(`Error getting last submission`, error);
          }
          this.fetchingSubmission = false
        },
				async getAssignmentByPostId() {
					try {
            this.assignment = await AssignmentService.findById(this.postId)
          } catch (error) {
            console.error(`Error getting assignment by post id: ${JSON.stringify(error)}`)
          }
				}
      },
      components: {
        Button,
        UISpinner,
        FileTab,
        BaseIcon
      }
  })
  